// Libs
import { Session } from "@collectivehealth/cog";
import {
  initializeAmplitudeForEmployer,
  initializeForLocalDev,
  setAmplitudeUser
} from "@collectivehealth/frontend-analytics";

// Utils
import { isLocal, isProd } from "utils/env";
import { isPosing } from "utils/posing/posing";

export function initializeAmplitude() {
  if (isLocal()) {
    initializeForLocalDev();
  } else {
    initializeAmplitudeForEmployer(isProd(), isPosing());
  }

  setAmplitudeUser(Session.getSession().sub);
}

export function unsetUser() {
  setAmplitudeUser(undefined, {});
}
